import { Container, Typography } from "@material-ui/core";
import { useCallback, useState } from "react";
import Page from "src/components/Page";
import { Titulo } from "src/components/Titulo";
import ModalSubirArchivo from "src/components/Modal/propuestas/Modal-subir-archivo";
import TablaPropuestasUnificada from "src/components/propuesta/TablaPropuestasUnificada";

export default function Propuestas() {
  const [abrirModalArchivo, setAbrirModalArchivo] = useState(false);
  const [propuestaSeleccionada, setPropuestaSeleccionada] = useState(null);

  const handleUploadFile = useCallback((propuesta) => {
    setPropuestaSeleccionada(propuesta);
    setAbrirModalArchivo(true);
  }, []);

  return (
    <Page title="TAXTIC">
      <Container maxWidth="xl">
        <Titulo>
          <Typography variant="h4" gutterBottom>
            Propuestas
          </Typography>
        </Titulo>
        <TablaPropuestasUnificada onUploadFile={handleUploadFile} />
      </Container>
      {abrirModalArchivo && (
        <ModalSubirArchivo
          open={abrirModalArchivo}
          setOpen={setAbrirModalArchivo}
          propuesta={propuestaSeleccionada}
        />
      )}
    </Page>
  );
}
